import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import {setMapHtml} from './indexHelper/index';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './hearbymap/src/css/hearby-widget-map-1.0.css';
import './carousel-react/src/css/hearby-widget-reactcarousel-1.0.css';
import './hearby-widget-powersearchbar-1.1.css';
import { mainCarouselConfigObj} 
  from './carouselConfigObj';
import { getPosition } from './utils/geolocation';
import { isHearby } from './config';
import { renderComponents, renderComponentsDma } from './indexHelper/render';
import _ from 'lodash';
window.componentsLoaded = false;
window.geoTimeout = false;
window.defaultLocLoaded = false;
window.userLocLoaded = false;
window.errorFired = false;
const options = {
  enableHighAccuracy: true,
  timeout: 2000,
  maximumAge: 0
};
(async function () {
  setMapHtml(window.powersearchUserSettings);
  /**
   * Init Map on 'js-map'
   * Add API Key
   */

if(window.powersearchUserSettings.geolocation) {
  setTimeout(
    function () {
      let settings = window.powersearchUserSettings;
      const carouselConfig = mainCarouselConfigObj;
  //    console.log('timeout fired');
      if(!window.errorFired) {
        isHearby ? renderComponentsDma(settings, carouselConfig) : renderComponents(settings, carouselConfig)
      }
      window.defaultLocLoaded = true;
      window.componentsLoaded = true;
      window.geoTimeout = true;
    },
    3000);
  try {
    let settings = _.cloneDeep(window.powersearchUserSettings);
    const position = await getPosition(options);
    const newPos =  {lat: position.coords.latitude, lon: position.coords.longitude};
    settings.defaultLocation = {lat: position.coords.latitude, lon: position.coords.longitude};
    let carouselConfig = mainCarouselConfigObj;
    carouselConfig.lat = newPos.lat;
    carouselConfig.lon = newPos.lon;
  //  console.log('geo fired ');
    isHearby ? renderComponentsDma(settings, carouselConfig) : renderComponents(settings, carouselConfig)
   window.userLocLoaded = true;
   window.componentsLoaded = true;
  } catch (err) {
    let settings = window.powersearchUserSettings;
    if(isHearby) {
      settings.defaultLocation = {lat: 42.3601, lon: -71.0589};
    }
    const carouselConfig = mainCarouselConfigObj;
    //console.log('err fired ');
    if(!window.geoTimeout) {
      isHearby ? renderComponentsDma(settings, carouselConfig) : renderComponents(settings, carouselConfig)
    }
    window.defaultLocLoaded = true;
    window.componentsLoaded = true;
    window.errorFired = true;
  }

} else {
  let settings = window.powersearchUserSettings;
  //console.log('no geo fired ');
  if(isHearby) {
    settings.defaultLocation = {lat: 42.3601, lon: -71.0589};
  }
  const carouselConfig = mainCarouselConfigObj;
  isHearby ? renderComponentsDma(settings, carouselConfig) : renderComponents(settings, carouselConfig)
  window.defaultLocLoaded = true;
  window.componentsLoaded = true;
}



  


// partner widget path
// '/wp-content/plugins/a4powersearch-wp/powersearch/build'
// hearby home path
// '/wp-content/plugins/hearby-filters-react/powersearch-new/build'
}) ();
